import React from 'react';
import { useNavigate } from 'react-router-dom';

export const ProjectTable = ({ projects, isLoading, statusClassMap, formatDate }) => {
    const skeletonRows = Array.from({ length: 8 }, (_, index) => index);
    const navigate = useNavigate();

    const handleRowClick = (projectId, projectName) => {
        navigate(`/project/detail/${projectId}`, {
            state: {
                projectName,
            },
        });
    };

    const handleCustomerClick = (customerId, customerName) => {
        if (!customerId) return;

        navigate(`/customer/detail/${customerId}`, {
            state: {
                customerName,
            },
        });
    };

    return (
        <div className="table-responsive border rounded-3">
            <table className="table table-hover align-middle mb-0">
                <thead>
                    <tr>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Código</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Proyecto</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Cliente</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Estatus</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Inicio</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Fin</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading && (
                        <>
                            {skeletonRows.map((row) => (
                                <tr key={`project-skeleton-${row}`}>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--badge"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--name"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--contact"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--status"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--date"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--date"></div></td>
                                </tr>
                            ))}
                        </>
                    )}

                    {!isLoading && projects.map((project) => (
                        <tr key={project._id}>
                            <td className="py-0">
                                <span className="link__nocolor badge bg-soft-primary text-primary" onClick={() => handleRowClick(project._id, project.name)}>{project.code}</span>
                            </td>
                            <td className="py-0">
                                <div className="link fw-semibold" onClick={() => handleRowClick(project._id, project.name)}>{project.name}</div>
                            </td>
                            <td className="py-0">
                                {project.customerId ? (
                                    <span
                                        className="link fw-semibold"
                                        onClick={() => handleCustomerClick(project.customerId, project.customerName)}
                                    >
                                        {project.customerName || '-'}
                                    </span>
                                ) : (project.customerName || '-')}
                            </td>
                            <td>
                                <span className={`badge ${statusClassMap[project.status] || 'bg-soft-secondary text-secondary'}`}>
                                    {project.status}
                                </span>
                            </td>
                            <td className="py-0">{formatDate(project.startDate)}</td>
                            <td className="py-0">{formatDate(project.endDate)}</td>
                        </tr>
                    ))}

                    {!isLoading && projects.length === 0 && (
                        <tr>
                            <td colSpan={6} className="text-center text-muted py-4">
                                No se encontraron proyectos con ese criterio de búsqueda.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};
